import Page from "@src/layout/Page";

export const PrivacyPolicy = () => {
    return (
        <Page>
            <div data-custom-class="body">
                <h1>Privacy Policy</h1>
                <p>
                    Here is a very succint privacy policy, to act as an agreement between
                    me, the developer/ owner and you, the user, whenever you use my web
                    application.
                </p>

                <h2>Personal information :</h2>
                <p>
                    Through this web application, I collect the following information from
                    you:
                    <ul>
                        <li>a username</li>
                        <li>an e-mail</li>
                        <li>a password</li>
                        <li>a link to a social network/website that you own.</li>
                    </ul>
                    This information is collected purely for identifying and securing your
                    account, and making sure you follow the terms and conditions.
                </p>

                <h2>Third Party</h2>
                <h3>Sentry</h3>
                <p>
                    To monitor errors, bugs and to improve this application, I use Sentry.
                    <br />
                    Through this service, I receive information about errors, such as the
                    nature of the browser, where and how it happened. While this information
                    is anonymous, I (the developper and owner), could easily link the
                    requests made to a particular user.
                </p>
                <h3>hCaptcha</h3>
                <p>
                    I use the hCaptcha security service (hereinafter "hCaptcha") on my
                    website. This service is provided by Intuition Machines, Inc., a
                    Delaware US Corporation ("IMI"). hCaptcha is used to check whether user
                    actions on our online service (such as submitting a login or contact
                    form) meet our security requirements. To do this, hCaptcha analyzes the
                    behavior of the website or mobile app visitor based on various
                    characteristics. This analysis starts automatically as soon as the
                    website or mobile app visitor enters a part of the website or app with
                    hCaptcha enabled. For the analysis, hCaptcha evaluates various
                    information (e.g. IP address, how long the visitor has been on the
                    website or app, or mouse movements made by the user). The data collected
                    during the analysis will be forwarded to IMI. hCaptcha analysis in the
                    "invisible mode" may take place completely in the background. Website or
                    app visitors are not advised that such an analysis is taking place if
                    the user is not shown a challenge. Data processing is based on Art.
                    6(1)(b) of the GDPR: the processing of personal data is necessary for
                    the performance of a contract to which the website visitor is party (for
                    example, the website terms) or in order to take steps at the request of
                    the website visitor prior to entering into a contract. Our online
                    service (including our website, mobile apps, and any other apps or other
                    forms of access offered by us) needs to ensure that it is interacting
                    with a human, not a bot, and that activities performed by the user are
                    not related to fraud or abuse. In addition, processing may also be based
                    on Art. 6(1)(f) of the GDPR: our online service has a legitimate
                    interest in protecting the service from abusive automated crawling,
                    spam, and other forms of abuse that can harm our service or other users
                    of our service. IMI acts as a "data processor" acting on behalf of its
                    customers as defined under the GDPR, and a "service provider" for the
                    purposes of the California Consumer Privacy Act (CCPA). For more
                    information about hCaptcha’s privacy policy and terms of use, please
                    visit the following links: https://www.hcaptcha.com/privacy and
                    https://www.hcaptcha.com/terms
                </p>
                <h2>Data Ownership</h2>
                <p>
                    I claim no ownership over the data that a user sends to my application.
                    You retain all ownership of images and concepts that are yours (this is
                    not the place but theft will not be tolerated)
                </p>
                <p>
                    While it is not setup yet, should you wish to delete you account and all
                    data linked to it (characters and links as of right now), please contact
                    me @ <a href="mailto:support@charsh.app">support@charsh.app</a> and
                    unless I am physically unable to, I will do so within 42hours.
                </p>
            </div>
        </Page>
    );
}

